export default {
    cantico: {
      title: 'Il Cantico delle Creature',
      subtitle: 'di San Francesco d\'Assisi',
      headerOriginal: 'Lingua originale del 1225',
      headerTranslations: 'Versione in cinese',
      text: `至高、全能、仁慈的主啊，赞美、荣耀、尊贵和一切
祝福都归于你。唯有你才是它们的主人，无人配得上
提及你

赞美你，我的主，感谢你创造的一切，尤其感谢太阳
兄弟，他是白昼之光，你借着他照亮我们：他美丽而
光辉灿烂，承载着至高无上的你

我的主啊，赞美你，通过月亮和星星：你在天堂创造
了它们，它们清澈、珍贵、美丽

赞美你，我的主，通过风兄弟，通过空气，通过天
空；通过阴天和晴天，通过你赐予万物生灵的每一个
季节

主啊，愿称受赞美，这赞美藉由水姐妹而来，她非常
有用、谦逊、珍贵、纯洁

主啊，赞美你，藉着火神兄弟，你照亮了黑夜。他美
丽、喜乐、健壮、强壮

赞美你，我的主，通过我们的⼤地母亲，她养育我
们、治理我们：她孕育出各种果实、五彩缤纷的花朵
和青草

赞美你，我的主，感谢那些因你的爱而宽恕他人，并
忍受痛苦和疾病的人。那些平静忍受苦难的人是有福
的，因为至高者啊，他们将从你那里得到冠冕

主啊，赞美你，因为你赐予我们肉体的死亡，这是任
何活着的人都无法逃脱的；那些死于大罪中的人有祸
了。那些在遵行你的旨意时死去的人是有福的。在这
种情况下，灵性上的死亡不会伤害他们

赞美主、称颂主、感谢主，并以极大的谦卑服侍主`
    }
  }